module.exports = __webpack_public_path__ + "static/media/icon-memo.b46d31c3.svg";